import { getUserStatus } from '../../utils/indexedDBFunctions';
import { setIsOnline } from './offlineSlice';

const initializeOfflineMode = async (dispatch) => {
  const userStatus = await getUserStatus();
  if (userStatus === 'offline') {
    dispatch(setIsOnline(false));
  } else {
    dispatch(setIsOnline(true));
  }
};

export default initializeOfflineMode;